import React from 'react';
import { Grid, Typography } from '@material-ui/core';
import { useTranslation } from 'react-i18next';

function Temperatures(props) {
  const { profile, name, temperature } = props;
  const { t } = useTranslation();
  return (
    <>
      <Grid item xs={12} style={{ marginTop: 10 }}>
        <Typography>{name}</Typography>
      </Grid>
      <Grid
        item
        xs={6}
        style={{ textAlign: 'right', paddingRight: 10, marginTop: 10 }}
      >
        <Typography>
          {t('productGroups.viewDetails.minimumTemperature')}
        </Typography>
      </Grid>
      <Grid item xs={6} style={{ marginTop: 10, color: 'grey' }}>
        <Typography>
          {profile[temperature].minC}°C / {profile[temperature].minF}°F
        </Typography>
      </Grid>
      <Grid
        item
        xs={6}
        style={{ paddingRight: 10, textAlign: 'right', marginTop: 10 }}
      >
        <Typography>
          {t('productGroups.viewDetails.maximumTemperature')}
        </Typography>
      </Grid>
      <Grid
        item
        xs={6}
        style={{ marginTop: 10, color: 'grey', marginBottom: 10 }}
      >
        <Typography>
          {profile[temperature].maxC}°C / {profile[temperature].maxF}°F
        </Typography>
      </Grid>
    </>
  );
}

export default Temperatures;
